import { UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

interface UseParams {
  userId: string;
  locationId: string;
  xTENANTID?: string;
}

/**
 * @author Shrinivas Mandhare
 */
export const useAssignLocationToUser = () =>
  useMutationWithLoading(async (params: UseParams) =>
    new UserControllerApi(getConfigObject()).assignLocationToUser(
      params.userId,
      params.locationId,
      params.xTENANTID
    )
  );
